import React from 'react';
import { styled } from '@mui/material/styles';
import VideoFile from '@mui/icons-material/VideoFile';
import ButtonComponent from "components/Button";

const Input = styled('input')({
    display: 'none',
});

const VideoButton = ({onFileSelect, idx, multiple = false}) => {

    return (
        <label htmlFor={`contained-button-video-${idx}`}>
            <Input 
                accept="video/*" 
                id={`contained-button-video-${idx}`} 
                type="file" 
                onChange={onFileSelect}
                multiple={multiple}
            />
            <ButtonComponent
                sx={{
                    m: 2,
                    color: 'text.lightprimary',
                }}
                endIcon={<VideoFile />}
                type="primary"
                variant="contained"
                size="small"
                name="Videos"
                component="span"
            />
        </label>
    )
}


export default VideoButton;

